import {MessageProducer, ValidateIf} from '../validate-core'
import MinLength from './MinLength'

export default function IsNotEmpty<T>(
    message?: string | MessageProducer<T>,
    validateIf?: ValidateIf<T>
) {
    return MinLength(1, message, validateIf)
}
